import React from 'react';
import { Stack, Button, Link } from '@chakra-ui/react';
import Layout from '../../components/Layout';
import FeatureTable from './FeatureTable';
import HeroWithBackgroundImage from '../../components/shared/HeroWithBackgroundImage';

const MEASUREMENTS_TABLE = {
  headers: [
    { title: '', description: '' },
    {
      title: 'ROOF-ONLY REPORT',
      description: 'Good for quick roof measurements',
    },
    {
      title: 'COMPLETE REPORT',
      description: 'Better for detailed exterior measurements ',
    },
  ],
  rows: [
    { title: 'Roof footprints', availableInRoofOnly: true },
    {
      title:
        'Roof facets, pitches, ridges/hips, valleys, rakes, eaves, flashing, step flashing, drip edge/perimeter',
      availableInRoofOnly: true,
    },
    {
      title: 'Soffit footprint with the depth, length and area for each soffit',
      availableInRoofOnly: true,
    },
    {
      title: 'Gutters and downspout sketch, count and length',
      availableInRoofOnly: false,
    },
    {
      title: 'Areas for each facade and siding per elevation',
      availableInRoofOnly: false,
    },
    {
      title: 'Facades, elevations',
      availableInRoofOnly: false,
    },
    {
      title: 'Area and length for level starter, sloped trim and vertical trim',
      availableInRoofOnly: false,
    },
    {
      title: 'Quantity and length for inside and outside corners',
      availableInRoofOnly: false,
    },
    {
      title: 'Siding waste factor calculations',
      availableInRoofOnly: false,
    },
    {
      title:
        'Areas and length for eaves fascia, level frieze board, rakes and sloped frieze boars',
      availableInRoofOnly: false,
    },
    {
      title:
        'Quantity, tops length, sills length, sides length, total perimeter, width and height, united inches and area for all openings',
      availableInRoofOnly: false,
    },
    {
      title: 'Quantity and area for shutters and vents',
      availableInRoofOnly: false,
    },
    {
      title: 'Elevation sketches',
      availableInRoofOnly: false,
    },
  ],
};

const MeasurementsOverview = () => (
  <Layout
    title="Measurements Overview"
    description="HOVER delivers the most detailed and accurate measurements within the industry.
    Here’s an overview of all the information that is included in our Measurements Reports."
  >
    <HeroWithBackgroundImage
      title="Measurements Overview"
      imageUrl=""
      description="HOVER delivers the most detailed and accurate measurements within the industry.
            Here’s an overview of all the information that is included in our Measurements Reports."
    />
    <Stack direction="column" alignItems="center" maxW="6xl" mx="auto">
      <FeatureTable
        headers={MEASUREMENTS_TABLE.headers}
        rows={MEASUREMENTS_TABLE.rows}
      />
      <Link href="https://hover.to/signup/">
        <Button size="lg">First Property For Free</Button>
      </Link>
    </Stack>
  </Layout>
);

export default MeasurementsOverview;
